import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Divider, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import { toast } from 'react-toastify'
// import { ApiGetVenueList, ApiQuestionSummaryReport, ApiSiteSummary } from '../../apiService/Core/Apicall'
import dayjs from 'dayjs'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import usePagination from '@mui/material/usePagination/usePagination'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ApiGetQuestions } from '../../apiService/Core/Apicall.tsx'
import html2pdf from 'html2pdf.js';


function Questions() {
    const [questionsummary, setquestionsummary] = useState<any>()
    const [months, setmonths] = useState<any>(dayjs())
    const location = useLocation();
    const { venueId, clientEntityId, venue, DateofVisit, TimeofVisit } = location.state || {};
    const navigate = useNavigate()
    const pdfRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const questionsummary = async () => {
            if (venueId && months) {

                try {

                    const data = `?venueId=${venueId}&clientEntityId=${clientEntityId}`
                    const response = await ApiGetQuestions(data)
                    setquestionsummary(response.data)
                } catch (error: any) {
                    const message =
                        error?.response?.data?.message || // API error message
                        error?.message ||                 // JS error message
                        String(error);
                    toast.error(message)
                }
            }
        }
        questionsummary()
    }, [])


    const handleDownloadPdf = () => {
        if (pdfRef.current) {
            const opt = {
                margin: 0.2,
                filename: 'shopper-terms.pdf',
                image: { type: 'png',quality: 1},
                html2canvas: { scale: 2, useCORS: true},
                jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
            };

            html2pdf()
                .from(pdfRef.current)
                .set(opt)
                .outputPdf('blob')
                .then((pdfBlob: Blob) => {
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    window.open(pdfUrl, '_blank');
                    setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
                });
        }
    };

    return (
        <Box className='p-3'>
            <Box className='d-flex justify-content-between'>
                <Button onClick={() => { navigate(-1); localStorage.setItem('ActiveTask', 'MyTask') }} className='button-primary px-4 py-1'>Back</Button>
                <Button onClick={() => { handleDownloadPdf() }} className='button-primary px-4 py-1'>Print</Button>
            </Box>
            <Box ref={pdfRef}>
                <Box className='border-10 mt-4 mb-3' sx={{ border: '1px solid black' }}>
                    <Box className='d-flex p-2 align-items-center pb-1' borderBottom='1px solid black' gap={2}>
                        <Typography variant='subtitle2' minWidth={'85px'}>Venue:</Typography>
                        <Typography variant='subtitle2'>{venue}</Typography>
                    </Box>
                    <Box className='d-flex p-2 align-items-center pb-1' borderBottom='1px solid black' gap={2}>
                        <Typography variant='subtitle2'>Date of Visit:</Typography>
                        <Typography variant='subtitle2'>{DateofVisit}</Typography>
                    </Box>
                    <Box className='d-flex p-2 align-items-center pb-1' gap={2}>
                        <Typography variant='subtitle2'>Time of Visit:</Typography>
                        <Typography variant='subtitle2' >{TimeofVisit}</Typography>
                    </Box>
                </Box>
                <Divider className='my-3' sx={{ borderColor: 'black' }} />
                {questionsummary && questionsummary.map((item: any, index: any) => (
                    <Box  className='my-2 w-100 border-10 p-2 question-block ' sx={{ border: '1px solid #ADB792' }}>
                        <Box className='d-flex align-items-center justify-content-between'>
                            <Typography className='text-main' fontWeight='bold' variant='h6'>Question {index + 1}</Typography>
                            <Typography className='px-4 py-1 border-10' variant='caption' bgcolor='#ADB7922A'>{item.categoryName}</Typography>
                        </Box>
                        <Typography className='text-start mt-2'>{item.questions}</Typography>

                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default Questions
